let pledgePaySurface = null;

function setPledgePaySurface(surface) {
    if (surface) {
        pledgePaySurface = surface;
    }
}

function getPledgePaySurface($container) {
    if (pledgePaySurface) {
        return pledgePaySurface;
    }
    const fromRoot = $container.closest('[data-pledge-pay-surface]').attr('data-pledge-pay-surface');
    if (fromRoot) {
        return fromRoot;
    }
    if ($container.is('[data-pledge-pay-surface]')) {
        return $container.attr('data-pledge-pay-surface');
    }
    return 'member_page';
}

function buildPledgePayTableContext($container, payType, isRecurringMode, surfaceOverride) {
    const resolvedPayType = payType || $container.find('#payment_type').val() || 'pay';
    const surface = surfaceOverride || getPledgePaySurface($container);
    return {
        surface,
        payType: resolvedPayType,
        isRecurringMode: !!isRecurringMode,
    };
}

function resolveTableLayout(tableContext, pledges) {
    if (tableContext.isRecurringMode) {
        return 'recurring_draggable';
    }
    if (tableContext.payType === 'mark') {
        return 'flat_amount_inputs';
    }
    if (tableContext.surface === 'member_page') {
        return 'flat_amount_inputs';
    }
    if (tableContext.surface === 'statement' && pledges.length > 1) {
        return 'statement_selectable';
    }
    return 'gateway_grouped';
}

function resolvePledgePayTableProfile(tableContext, pledges) {
    const layout = resolveTableLayout(tableContext, pledges);
    const isMgrStylePayUi = tableContext.surface === 'manager_modal'
        || tableContext.surface === 'manager_page';
    return {
        layout,
        isMarkPaid: tableContext.payType === 'mark',
        inPaymentModal: tableContext.surface === 'manager_modal',
        isMgrStylePayUi,
        showSelectColumn: layout === 'statement_selectable',
        useFlatTable: layout === 'flat_amount_inputs' || layout === 'recurring_draggable',
    };
}

function isStatementEmailPayment() {
    return pledgePaySurface === 'statement';
}

export {
    setPledgePaySurface,
    getPledgePaySurface,
    buildPledgePayTableContext,
    resolveTableLayout,
    resolvePledgePayTableProfile,
    isStatementEmailPayment,
};
